import React from 'react';
import './ResetPasswordPageComponent.less';
import ResetPasswordComponent from '../ResetPasswordComponent/ResetPasswordComponent';

function ResetPasswordPageComponent({lingua, updatePage}) {
    return (
        <div className="border-border-color">
            <ResetPasswordComponent lingua={lingua} updatePage={updatePage}/>
        </div>
    );
}

export default ResetPasswordPageComponent;
